"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth0AccessToken = void 0;
var is_not_empty_string_1 = require("../class-validators/is-not-empty-string");
var class_validator_1 = require("class-validator");
var auth0_access_token_builder_1 = require("../builders/auth0-access-token-builder");
var class_transformer_1 = require("class-transformer");
var case_insensitive_ingest_1 = require("../class-transformers/case-insensitive-ingest");
var abstract_struct_1 = require("./abstract-struct");
var Auth0AccessToken = (function (_super) {
    __extends(Auth0AccessToken, _super);
    function Auth0AccessToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Auth0AccessToken, "Builder", {
        get: function () {
            return new auth0_access_token_builder_1.Auth0AccessTokenBuilder();
        },
        enumerable: false,
        configurable: true
    });
    Auth0AccessToken.buildFromAuth0Jwt = function (jwt) {
        if (!jwt || typeof jwt !== 'object') {
            throw new Error('Invalid Auth0 JWT passed. Object expected.');
        }
        var container = jwt;
        return this.Builder.setIss(container.iss)
            .setSub(container.sub)
            .setAud(container.aud)
            .setIat(container.iat)
            .setExp(container.exp)
            .setAzp(container.azp)
            .setScope(container.scope)
            .setPushlyUserId(container.pushly_user_id)
            .setAuth0UserId(container.auth0_user_id)
            .setTenantName(container.tenant_name)
            .setOrgId(container.org_id)
            .setAppMetadata(container.app_metadata)
            .build();
    };
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Auth0AccessToken.prototype, "iss", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Auth0AccessToken.prototype, "sub", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Auth0AccessToken.prototype, "aud", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Auth0AccessToken.prototype, "iat", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Auth0AccessToken.prototype, "exp", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Auth0AccessToken.prototype, "azp", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Auth0AccessToken.prototype, "scope", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'pushly_user_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Auth0AccessToken.prototype, "pushlyUserId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'auth0_user_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Auth0AccessToken.prototype, "auth0UserId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'tenant_name' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Auth0AccessToken.prototype, "tenantName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'org_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Auth0AccessToken.prototype, "orgId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'app_metadata' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Auth0AccessToken.prototype, "appMetadata", void 0);
    return Auth0AccessToken;
}(abstract_struct_1.AbstractStruct));
exports.Auth0AccessToken = Auth0AccessToken;
//# sourceMappingURL=auth0-access-token.js.map